var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15571_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90918 5.61456L2.54554 13.0951C2.54554 13.5359 2.72433 13.9588 3.04258 14.2705C3.36082 14.5823 3.79245 14.7574 4.24251 14.7574H9.75767C10.2077 14.7574 10.6393 14.5823 10.9576 14.2705C11.2759 13.9588 11.4546 13.5359 11.4546 13.0951L12.091 5.61456",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27271 8.52362V12.2556",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72729 8.52362V12.2556",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06055 3.74445H12.9393",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12133 3.74442V2.08208C9.12133 1.86165 9.0319 1.65023 8.87281 1.49436C8.71372 1.33849 8.49786 1.25092 8.27285 1.25092H5.72739C5.50237 1.25092 5.28654 1.33849 5.12742 1.49436C4.9683 1.65023 4.87891 1.86165 4.87891 2.08208V3.74442",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15571_483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTrash);
export default __webpack_public_path__ + "static/media/white-trash.7f3f4783e6ff164e90b1d0d65f66b4c0.svg";
export { ForwardRef as ReactComponent };